import { render, staticRenderFns } from "./vehicle_status_history.vue?vue&type=template&id=307b50f3&scoped=true&"
import script from "./vehicle_status_history.vue?vue&type=script&lang=js&"
export * from "./vehicle_status_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b50f3",
  null
  
)

export default component.exports